import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React from "react";
import { Text, TextColor, TextSize, TextWeight } from "../../../components";
import { Button, ButtonSize, ButtonVariant } from "../../../components";
export const ReturnMethodOption = t0 => {
  const $ = _c(36);
  const {
    method,
    isSelected,
    onSelect,
    onSelectDhlPoint,
    dhlParcelPoint
  } = t0;
  const getPrice = _temp;
  const t1 = `border-2 p-4 cursor-pointer transition-all ${isSelected ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-300"}`;
  let t2;
  if ($[0] !== method || $[1] !== onSelect) {
    t2 = () => onSelect(method);
    $[0] = method;
    $[1] = onSelect;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `w-5 h-5 rounded-full border-2 flex items-center justify-center mt-1 ${isSelected ? "border-blue-500 bg-blue-500" : "border-gray-300"}`;
  let t4;
  if ($[3] !== isSelected) {
    t4 = isSelected && <div className="w-2 h-2 bg-white rounded-full" />;
    $[3] = isSelected;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== method.image || $[9] !== method.title) {
    t6 = method.image && <Image src={method.image.replace("https://carry.pl", "https://shop.carry.pl")} alt={method.title} className="h-8 w-auto" width={100} height={37} />;
    $[8] = method.image;
    $[9] = method.title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== method.title) {
    t7 = <Text text={method.title} weight={TextWeight.BOLD} fontSize={TextSize.M} />;
    $[11] = method.title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `(${getPrice(method, true)})`;
  let t9;
  if ($[13] !== t8) {
    t9 = <Text text={t8} color={TextColor.GRAYSCALE_600} fontSize={TextSize.S} />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t9) {
    t10 = <div className="flex items-center gap-2 mb-2">{t6}{t7}{t9}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== method.desc) {
    t11 = <Text textHtml={method.desc} color={TextColor.GRAYSCALE_600} fontSize={TextSize.S} />;
    $[19] = method.desc;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== dhlParcelPoint || $[22] !== method.idReturnMethod || $[23] !== onSelectDhlPoint) {
    t12 = method.idReturnMethod === "3" && onSelectDhlPoint && <div className="mt-3"><Button text="Wybierz punkt" variant={ButtonVariant.SECONDARY} size={ButtonSize.S} onClick={e => {
        e.stopPropagation();
        onSelectDhlPoint();
      }} />{dhlParcelPoint && <div className="mt-2 p-2 bg-gray-50 rounded"><Text text={dhlParcelPoint.name} weight={TextWeight.BOLD} fontSize={TextSize.S} /><Text text={`${dhlParcelPoint.street} ${dhlParcelPoint.streetNo}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /><Text text={`${dhlParcelPoint.zip} ${dhlParcelPoint.city}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /></div>}</div>;
    $[21] = dhlParcelPoint;
    $[22] = method.idReturnMethod;
    $[23] = onSelectDhlPoint;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12) {
    t13 = <div className="flex-1">{t10}{t11}{t12}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t5) {
    t14 = <div className="flex items-start gap-4">{t5}{t13}</div>;
    $[29] = t13;
    $[30] = t5;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t1 || $[33] !== t14 || $[34] !== t2) {
    t15 = <div className="w-full mb-4"><div className={t1} onClick={t2}>{t14}</div></div>;
    $[32] = t1;
    $[33] = t14;
    $[34] = t2;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
function _temp(method_0, isSubscribed) {
  if (method_0.regularPrice === "0.00") {
    return "Bezp\u0142atne";
  }
  const price = isSubscribed ? method_0.discountPrice : method_0.regularPrice;
  return `${price} PLN`;
}